import styled from "@emotion/styled";
import { ScrollDirection } from "./fade-horizontal-scroll.hooks";
import { MDSIconButton } from "@/mds/components/buttons/icon-button";

export const StyledIconButton = styled(MDSIconButton)<{
  $isVisible: boolean;
  $direction: ScrollDirection;
}>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: ${({ theme }) => theme.zIndex.FloatingButton};
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  cursor: ${({ $isVisible }) => ($isVisible ? "pointer" : "default")};
  pointer-events: ${({ $isVisible }) => ($isVisible ? "auto" : "none")};
  left: ${({ $direction }) => ($direction === ScrollDirection.Left ? "3px" : "auto")};
  right: ${({ $direction }) => ($direction === ScrollDirection.Right ? "3px" : "auto")};
`;
